import { render } from "./sh-more.vue?vue&type=template&id=13824b3d&scoped=true"
import script from "./sh-more.vue?vue&type=script&lang=js"
export * from "./sh-more.vue?vue&type=script&lang=js"

import "./sh-more.vue?vue&type=style&index=0&id=13824b3d&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13824b3d"]])

export default __exports__